import api from "@/assets/js/utils/api.js"; // 🟢 和商品頁完全一樣
import { useHead } from "@vueuse/head";
import NewsViewModal from "@/components/NewsView.vue";

export default {
  components: {
    NewsViewModal,
  },

  setup() {
    // ✅ SEO 設定寫在 setup() 裡才會生效
    useHead({
      title: "安裕和國際企業社｜動物醫療專業設備・臨床嚴選",
      meta: [
        {
          name: "description",
          content:
            "安裕和國際企業社提供動物醫院專用醫療設備與臨床耗材，嚴選高品質、提升療效，深受臨床團隊信賴。",
        },
        {
          name: "keywords",
          content: "動物醫療, 醫療設備, 臨床耗材, 動物醫院採購, 寵物醫療",
        },
        { property: "og:title", content: "安裕和國際企業社" },
        {
          property: "og:description",
          content: "臨床嚴選醫療設備｜動物醫院專用｜品質安全可靠",
        },
        {
          property: "og:image",
          content: "https://www.annyoohoh.com.tw/img/AYH.f5146a33.png", // 換成你的
        },
        { property: "og:type", content: "website" },
      ],

      link: [
        {
          rel: "canonical",
          href: "https://www.annyoohoh.com.tw/",
        },
      ],
    });
  },

  data() {
    return {
      showNews: false,
      imageAspectRatios: [], // 新增:儲存每張圖片的比例
      // 常見問題
      activeFAQ: null,
      faqs: [
        {
          question: "採購方式彈性嗎？",
          answer:
            "非常彈性。<br>🔹 可少量導入<br>🔹 可混搭採購<br>🔹 可依需求規劃庫存量<br>→ 不綁約、不增加負擔",
        },
        {
          question: "遇到產品問題，有售後嗎？",
          answer:
            "有。<br>我們協助找原因、改善、必要時更換。<br>💬 一通訊息即可處理。<br>我們重視長期合作，不讓院所自行面對問題。",
        },
        {
          question: "有臨床案例或使用教學可以參考嗎？",
          answer:
            "有提供。<br>📍 案例精華<br>📍 使用技巧<br>→ 提升療效、提升護主信任感",
        },
        {
          question: "我想了解更多，怎麼聯繫？",
          answer:
            "✔ 官網諮詢表單<br>✔ 直撥電話<br>留下訊息，1 位專屬業務立即協助你<br>→ 最快 24 小時內啟動合作",
        },
      ],
      // 熱門產品
      products: [],
      currentProduct: 0,

      // 首頁橫幅輪播
      slides: [],
      current: 0,
      timer: null,
      isTransitioning: true,
      productDots: 3, // ✅ 指示點數量 = 真正產品數

      touchStartX: 0, // 記錄手指開始位置
      touchMoveX: 0, // 記錄滑動距離
    };
  },

  computed: {
    // ✅ 熱門產品滑動動畫
    productTrackStyle() {
      if (this.products.length === 0) return {};

      // 永遠避免 index 超出
      const safeIndex = this.currentProduct % (this.products.length + 1);

      return {
        transform: `translateX(-${safeIndex * 100}%)`,
        transition: this.isTransitioning ? "transform 0.4s ease" : "none",
      };
    },
  },

  methods: {
    async loadBanner() {
      try {
        const res = await api.get("/banner/list");

        if (res.data?.success && Array.isArray(res.data.data)) {
          // 🕒 目前時間
          const now = new Date();

          // 🟢 篩選條件：
          // 1. IsActive = true
          // 2. now 在 StartTime ~ EndTime 之間
          const validBanner = res.data.data.filter((item) => {
            const start = new Date(item.StartTime);
            const end = new Date(item.EndTime);

            const isInPeriod = now >= start && now <= end;
            const isActive = item.IsActive === true;

            return isActive && isInPeriod; // ⭐ 必須全部成立才顯示
          });

          // 🚨 沒有符合 → 預設圖避免空白畫面
          if (validBanner.length === 0) {
            this.slides = [
              {
                image: require("@/assets/image/AYH.webp"),
                title: "預設 Banner",
              },
            ];
            return;
          }

          // 🎯 將資料轉換前端格式
          this.slides = validBanner.map((item) => ({
            id: item.Id,
            title: item.Name,
            description: item.Description,
            image:
              item.ImageUrl && item.ImageUrl.trim() !== ""
                ? item.ImageUrl
                : require("@/assets/image/AYH.webp"),
          }));
        }
      } catch (err) {
        console.error("❌ Banner 載入失敗", err);

        // 🧯 fallback 預設
        this.slides = [
          { image: require("@/assets/image/AYH.webp"), title: "預設 Banner" },
        ];
      }
    },
    handleBannerImgError(e) {
      e.target.src = require("@/assets/image/AYH.webp");
      e.target.onerror = null;
    },

    // 常見問題開關
    toggleFAQ(index) {
      this.activeFAQ = this.activeFAQ === index ? null : index;
    },

    // 熱門產品切換
    nextProduct() {
      if (!this.isTransitioning) return; // 防止動畫期間重複觸發

      this.currentProduct++;
    },

    prevProduct() {
      if (!this.isTransitioning) return; // 防止動畫期間重複觸發

      if (this.currentProduct === 0) {
        // 在第一張時點「上一張」→ 先瞬移到 clone 的最後一張
        this.isTransitioning = false;
        this.currentProduct = this.products.length;

        this.$nextTick(() => {
          setTimeout(() => {
            this.isTransitioning = true;
            this.currentProduct = this.products.length - 1;
          }, 20);
        });
      } else {
        this.currentProduct--;
      }
    },

    handleTransitionEnd() {
      if (this.currentProduct === this.products.length) {
        // 滑到 clone 的第一張(索引 = products.length)
        this.isTransitioning = false;

        this.$nextTick(() => {
          this.currentProduct = 0; // 瞬移回真正的第一張

          setTimeout(() => {
            this.isTransitioning = true; // 恢復動畫
          }, 20);
        });
      }
    },
    // 首頁橫幅輪播
    nextSlide() {
      this.current = (this.current + 1) % this.slides.length;
      this.adjustCurrentSlideHeight(); // ✅ 新增
    },

    prevSlide() {
      this.current =
        (this.current - 1 + this.slides.length) % this.slides.length;
      this.adjustCurrentSlideHeight(); // ✅ 新增
    },

    goToSlide(index) {
      this.current = index;
      this.adjustCurrentSlideHeight(); // ✅ 新增
    },

    adjustCurrentSlideHeight() {
      this.$nextTick(() => {
        const currentSlide = this.$el.querySelectorAll(".slide")[this.current];
        if (currentSlide) {
          const img = currentSlide.querySelector("img");
          if (img && img.complete) {
            this.adjustBannerHeight(img);
          }
        }
      });
    },

    // 橫幅按鈕跳轉
    handleClick(index) {
      switch (index) {
        case 0:
          this.$router.push("/contact");
          break;
        case 1:
          // this.$router.push("/products");
          break;
        case 2:
          // this.$router.push("/education");
          break;
      }
    },

    goToProducts() {
      this.$router.push("/products");
    },

    goProductDetail(id) {
      this.$router.push(`/products/${id}`); // 導向單一商品頁
    },

    goToProduct(index) {
      this.isTransitioning = true; // 啟用動畫
      this.currentProduct = index;
    },

    // 手指按下
    onTouchStart(e) {
      this.touchStartX = e.touches[0].clientX; // 記錄開始位置
    },

    // 手指滑動
    onTouchMove(e) {
      this.touchMoveX = e.touches[0].clientX - this.touchStartX; // 記錄滑動距離
    },

    // 手指放開 → 判斷滑動方向
    onTouchEnd() {
      if (Math.abs(this.touchMoveX) > 50) {
        if (this.touchMoveX < 0) {
          this.nextProduct(); // 左滑 → 下一個
        } else {
          this.prevProduct(); // 右滑 → 上一個
        }
      }

      this.touchMoveX = 0; // 重置
    },

    startBannerTimer() {
      this.timer = setInterval(() => {
        this.nextSlide();
      }, 5000);
    },

    startProductTimer() {
      this.productTimer = setInterval(() => {
        this.nextProduct();
      }, 5000);
    },

    async loadRandomProducts() {
      try {
        const res = await api.get("/product/random");

        if (res.data?.success) {
          this.products = res.data.data.map((p) => ({
            id: p.Id,
            image:
              p.PictureURL && p.PictureURL.trim() !== ""
                ? p.PictureURL
                : require("@/assets/image/AYH.webp"),
            title: p.ProductName,
            desc: p.Description || "此商品沒有描述內容",
          }));

          this.productDots = this.products.length; // 更新 dots 數量
        }
      } catch (err) {
        console.error("隨機產品載入失敗：", err);
      }
    },

    handleImgError(e) {
      e.target.src = require("@/assets/image/AYH.webp"); // ← fallback 預設圖片
      e.target.onerror = null; // 防止無限觸發
    },

    handleImageLoad(event, index) {
      const img = event.target;
      const aspectRatio = img.naturalWidth / img.naturalHeight;

      // 儲存圖片比例
      this.imageAspectRatios[index] = aspectRatio;

      // 判斷是橫幅(>1)還是直立(<1)
      if (aspectRatio < 1) {
        // 直立圖
        img.classList.add("portrait-image");
        img.classList.remove("landscape-image");
      } else {
        // 橫幅圖
        img.classList.add("landscape-image");
        img.classList.remove("portrait-image");
      }

      // ✅ 新增:如果是當前顯示的圖片,立即調整容器高度
      if (index === this.current) {
        this.adjustBannerHeight(img);
      }
    },

    adjustBannerHeight(img) {
      this.$nextTick(() => {
        const banner = this.$el.querySelector(".home-banner");
        if (!banner || !img) return;

        const aspectRatio = img.naturalWidth / img.naturalHeight;

        if (aspectRatio > 1) {
          // 橫幅圖:根據圖片比例計算高度
          const containerWidth = banner.offsetWidth;
          const calculatedHeight = containerWidth / aspectRatio;

          // 設置容器高度,但不超過88vh
          const maxHeight = window.innerHeight * 0.88;
          const finalHeight = Math.min(calculatedHeight, maxHeight);

          banner.style.height = `${finalHeight}px`;
        } else {
          // 直立圖:恢復原本高度
          banner.style.height = "88vh";
        }
      });
    },
  },

  async mounted() {
    this.showNews = true;
    try {
      // 🔄 載入頁面所需的所有資料
      await this.loadBanner(); // ⬅️ 先取得 Banner
      await this.loadRandomProducts(); // ⭐ 抓後端 5 筆隨機商品

      // 🎬 啟動輪播功能
      this.startBannerTimer(); // ⬅️ 自動輪播
      this.startProductTimer(); // ⬅️ 原本的熱門產品輪播
      this.productDots = this.products.length;

      // 🎯 等待 DOM 更新完成
      this.$nextTick(() => {
        // 設定產品輪播事件監聽器
        const track = this.$el.querySelector(".product-track");
        if (track) {
          track.addEventListener("transitionend", this.handleTransitionEnd);
        }

        // ✅ 新增:初始化第一張圖片的容器高度
        this.adjustCurrentSlideHeight();

        // ✅ 新增:視窗大小改變時重新計算
        window.addEventListener("resize", this.handleResize);

        // ✅ 所有資料載入並 DOM 更新完成後，觸發預渲染事件
        if (typeof document !== "undefined") {
          document.dispatchEvent(new Event("render-event"));
        }
      });
    } catch (error) {
      console.error("首頁資料載入失敗:", error);

      // 🚨 即使資料載入失敗，也要觸發預渲染事件
      // 避免預渲染程序無限等待
      this.$nextTick(() => {
        if (typeof document !== "undefined") {
          document.dispatchEvent(new Event("render-event"));
        }
      });
    }
  },

  handleResize() {
    this.adjustCurrentSlideHeight();
  },

  beforeUnmount() {
    const track = this.$el.querySelector(".product-track");
    if (track) {
      track.removeEventListener("transitionend", this.handleTransitionEnd);
    }
    window.removeEventListener("resize", this.handleResize); // ✅ 新增
  },

  unmounted() {
    clearInterval(this.timer);
    clearInterval(this.productTimer); // ✅ 補上這個
  },
};
